import { render, staticRenderFns } from "./CustomerName.vue?vue&type=template&id=7c4caf82&"
import script from "./CustomerName.vue?vue&type=script&lang=js&"
export * from "./CustomerName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports